import { createStore, combineReducers, applyMiddleware, Store } from 'redux';
import thunk from 'redux-thunk';
import { tripReducer, userReducer, receiptReducer, receiptSummaryReducer } from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { ReceiptState } from '../types/receipt.store.type';
import { UserState } from '../types/user.store.type';
import { TripState } from '../types/trip.store.type';
import { ReceiptSummaryState } from '../types/receipt-summary.store.type';

const rootReducer = combineReducers({
    user: userReducer,
    trip: tripReducer,
    receipt: receiptReducer,
    receiptSummary: receiptSummaryReducer,
});

const isProduction = process.env.REACT_APP_CUSTOM_NODE_ENV && process.env.REACT_APP_CUSTOM_NODE_ENV === 'production';

let store: Store<{ receipt: ReceiptState; user: UserState; trip: TripState; receiptSummary: ReceiptSummaryState }>;

if (isProduction) {
    store = createStore(rootReducer, applyMiddleware(thunk));
} else {
    store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
}

export default store;
